/* eslint-disable no-restricted-globals */
/* eslint-disable class-methods-use-this */

class Front {
    constructor() {
        this.xDown = 0;
        this.yDown = 0;
    }

    init() {
        imagesLoaded(document.querySelector('img'), () => {
            setTimeout(() => {
                this.initImageSplit();
                this.initGalleryArchive();
            }, 800);
        });

        this.initEvents();

        this.events = {
            trackCursor() {
                if (!document.querySelector('body').classList.contains('gallery-visible')) {
                    document.querySelector('body').style.cursor = 'auto';
                    return;
                }
                const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                if (event.clientX > w / 2) {
                    document.querySelector('body').style.cursor = 'url("../../wp-content/themes/cmog-website/assets/media/cursors/right-arrow.png"), auto';
                }
                else {
                    document.querySelector('body').style.cursor = 'url("../../wp-content/themes/cmog-website/assets/media/cursors/left-arrow.png"), auto';
                }
            },
            onTouchStart() {
                const firstTouch = event.touches[0];
                this.xDown = firstTouch.clientX;
                this.yDown = firstTouch.clientY;
            },
            onTouchMove() {
                const imagesArray = document.querySelectorAll('.v-gallery-image');
                const arrayLength = imagesArray.length;

                if (!this.xDown) {
                    return;
                }

                const xUp = event.touches[0].clientX;
                const yUp = event.touches[0].clientY;
                const xDiff = this.xDown - xUp;
                const yDiff = this.yDown - yUp;
                const galleryLightbox = document.querySelector('.gallery-lightbox');
                const currentId = parseInt(galleryLightbox.getElementsByTagName('img')[0].id.replace('i', ''), 10);

                if (Math.abs(xDiff) > Math.abs(yDiff)) {
                    if (xDiff <= 0) {
                        if (currentId <= 1) {
                            return;
                        }

                        galleryLightbox.getElementsByTagName('img')[0].style.opacity = '0';

                        setTimeout(() => {
                            galleryLightbox.getElementsByTagName('img')[0].id = (currentId - 1);
                            galleryLightbox.getElementsByTagName('img')[0].setAttribute('src', imagesArray[currentId - 2].getAttribute('src'));
                            galleryLightbox.getElementsByTagName('img')[0].style.opacity = '1';

                            const tweenId = '#i' + galleryLightbox.querySelector('img').getAttribute('id').replace('i', '');
                            TweenLite.to(window, 0, { scrollTo: { y: tweenId } });
                        }, 400);
                    }
                    else {
                        if (currentId > arrayLength - 1) {
                            return;
                        }

                        galleryLightbox.getElementsByTagName('img')[0].style.opacity = '0';

                        setTimeout(() => {
                            galleryLightbox.getElementsByTagName('img')[0].id = (currentId + 1);
                            galleryLightbox.getElementsByTagName('img')[0].setAttribute('src', imagesArray[currentId].getAttribute('src'));
                            galleryLightbox.getElementsByTagName('img')[0].style.opacity = '1';

                            const tweenId = '#i' + galleryLightbox.querySelector('img').getAttribute('id').replace('i', '');
                            TweenLite.to(window, 0, { scrollTo: { y: tweenId } });
                        }, 400);
                    }
                }

                this.xDown = null;
                this.yDown = null;
            }
        };
    }

    initGalleryArchive() {
        if (document.querySelector('.masonry-grid > .sm-col-5')) {
            const gridItemsLeft = document.querySelector('.masonry-grid > .sm-col-5').querySelectorAll('.single-masonry-grid-item');
            const gridItemsRight = document.querySelector('.masonry-grid > .sm-col-7').querySelectorAll('.single-masonry-grid-item');

            // eslint-disable-next-line no-extra-boolean-cast
            if (!!gridItemsLeft) {
                for (let i = 0; i < gridItemsLeft.length; i += 1) {
                    setTimeout(() => {
                        gridItemsLeft[i].style.transform = 'scale(1)';
                        gridItemsLeft[i].style.opacity = 1;
                    }, (i * 1000));
                }
            }

            // eslint-disable-next-line no-extra-boolean-cast
            if (!!gridItemsRight) {
                for (let i = 0; i < gridItemsRight.length; i += 1) {
                    setTimeout(() => {
                        gridItemsRight[i].style.transform = 'scale(1)';
                        gridItemsRight[i].style.opacity = 1;
                    }, (i * 1000) + 500);
                }
            }
        }
    }

    initGalleryNavigation() {
        document.addEventListener('mousemove', this.events.trackCursor);

        const imagesArray = document.querySelectorAll('.v-gallery-image');
        const arrayLength = imagesArray.length;

        const closeGallery = document.querySelector('.close-gallery');
        closeGallery.addEventListener('click', (ev) => {
            ev.stopImmediatePropagation();
            document.querySelector('.gallery-lightbox').querySelector('img').classList.remove('reveal-image');
            document.querySelector('.revealer__inner').style.transform = 'translate(0%, 0%) matrix(1, 0, 0, 1, 0, 0)';
            setTimeout(() => {
                document.querySelector('body').classList.remove('gallery-visible');
                document.querySelector('.gallery-lightbox').querySelector('img').setAttribute('src', '');
                document.querySelector('body').style.cursor = 'auto';
                document.removeEventListener('mousemove', this.events.trackCursor);
                document.removeEventListener('touchstart', this.events.onTouchStart);
                document.removeEventListener('touchmove', this.events.onTouchMove);
            }, 500);
        });

        const galleryLightbox = document.querySelector('.gallery-lightbox');
        galleryLightbox.addEventListener('click', (ev) => {
            ev.stopImmediatePropagation();
            const currentId = parseInt(galleryLightbox.getElementsByTagName('img')[0].id.replace('i', ''), 10);
            const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            const x = ev.clientX;
            if (x > w / 2) { // right
                if (currentId > arrayLength - 1) {
                    return;
                }

                galleryLightbox.getElementsByTagName('img')[0].style.opacity = '0';
                galleryLightbox.querySelector('.image-info').style.opacity = '0';

                setTimeout(() => {
                    galleryLightbox.getElementsByTagName('img')[0].id = (currentId + 1);
                    galleryLightbox.getElementsByTagName('img')[0].setAttribute('src', imagesArray[currentId].getAttribute('src'));

                    document.querySelector('.gallery-lightbox').querySelector('.number').innerText = imagesArray[currentId].getAttribute('data-index') < 10 ? '0' + imagesArray[currentId].getAttribute('data-index') : imagesArray[currentId].getAttribute('data-index');
                    document.querySelector('.gallery-lightbox').querySelector('.title').innerText = imagesArray[currentId].getAttribute('alt');
                    document.querySelector('.gallery-lightbox').querySelector('.subtitle').innerText = imagesArray[currentId].getAttribute('data-description');

                    setTimeout(() => {
                        galleryLightbox.getElementsByTagName('img')[0].style.opacity = '1';
                        galleryLightbox.querySelector('.image-info').style.opacity = '1';
                    }, 400);

                    const tweenId = '#i' + galleryLightbox.querySelector('img').getAttribute('id').replace('i', '');

                    if (document.querySelector(tweenId)) {
                        TweenLite.to(window, 0, { scrollTo: { y: tweenId } });
                    }
                }, 400);
            }
            else { // left
                if (currentId <= 1) {
                    return;
                }

                galleryLightbox.getElementsByTagName('img')[0].style.opacity = '0';
                galleryLightbox.querySelector('.image-info').style.opacity = '0';

                setTimeout(() => {
                    galleryLightbox.getElementsByTagName('img')[0].id = (currentId - 1);
                    galleryLightbox.getElementsByTagName('img')[0].setAttribute('src', imagesArray[currentId - 2].getAttribute('src'));

                    document.querySelector('.gallery-lightbox').querySelector('.number').innerText = imagesArray[currentId - 2].getAttribute('data-index') < 10 ? '0' + imagesArray[currentId - 2].getAttribute('data-index') : imagesArray[currentId - 2].getAttribute('data-index');
                    document.querySelector('.gallery-lightbox').querySelector('.title').innerText = imagesArray[currentId - 2].getAttribute('alt');
                    document.querySelector('.gallery-lightbox').querySelector('.subtitle').innerText = imagesArray[currentId - 2].getAttribute('data-description');

                    galleryLightbox.getElementsByTagName('img')[0].style.opacity = '1';
                    galleryLightbox.querySelector('.image-info').style.opacity = '1';

                    const tweenId = '#i' + galleryLightbox.querySelector('img').getAttribute('id').replace('i', '');

                    if (document.querySelector(tweenId)) {
                        TweenLite.to(window, 0, { scrollTo: { y: tweenId } });
                    }
                }, 400);
            }
        });

        galleryLightbox.addEventListener('touchstart', this.events.onTouchStart, false);
        galleryLightbox.addEventListener('touchmove', this.events.onTouchMove, false);
    }

    initImageSplit() {
        inView('.split-image-top')
            .on('enter', (el) => {
                const img = el.querySelector('img');
                if (img.getAttribute('data-animated') !== 'true') {
                    img.setAttribute('data-animated', 'true');
                    const imageHeight = img.parentElement.getBoundingClientRect().height;
                    const middleTransformVar = imageHeight;
                    const bottomTransformVar = middleTransformVar * 2;

                    img.style.transform = 'matrix(1.05, 0, 0, 1.05, 0, 0)';
                    el.parentElement.children[1].querySelector('img').style.transform = 'matrix(1.05, 0, 0, 1.05, 0,-' + middleTransformVar + ')';
                    el.parentNode.children[2].querySelector('img').style.transform = 'matrix(1.05, 0, 0, 1.05, 0,-' + bottomTransformVar + ')';
                    img.parentElement.parentElement.parentElement.style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
                    img.parentElement.parentElement.parentElement.style.opacity = '1';
                    img.parentElement.parentElement.style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
                }

                const imgContainer = img.parentElement.parentElement;
                imgContainer.addEventListener('click', (ev) => {
                    document.querySelector('body').classList.add('gallery-visible');
                    this.initGalleryNavigation();
                    setTimeout(() => {
                        document.querySelector('.gallery-lightbox').querySelector('img').setAttribute('src', ev.target.getAttribute('src'));
                        document.querySelector('.gallery-lightbox').querySelector('img').setAttribute('id', img.getAttribute('id'));
                        document.querySelector('.gallery-lightbox').querySelector('.number').innerText = img.getAttribute('data-index') < 10 ? '0' + img.getAttribute('data-index') : img.getAttribute('data-index');
                        document.querySelector('.gallery-lightbox').querySelector('.title').innerText = img.getAttribute('alt');
                        document.querySelector('.gallery-lightbox').querySelector('.subtitle').innerText = img.getAttribute('data-description');
                        document.querySelector('.revealer__inner').style.transform = 'translate(0%, -100%) matrix(1, 0, 0, 1, 0, 0)';
                    }, 500);
                });
            });
    }

    initEvents() {
        inView('.ajax-trigger')
            .on('enter', (el) => {
                const formData = new FormData();
                formData.append('action', 'load_more_events');
                formData.append('pp', document.querySelector('.events-holder').getAttribute('data-per-page'));
                formData.append('paged', parseInt(document.querySelector('.events-holder').getAttribute('data-page'), 10) + 1);
                formData.append('exclude', document.querySelector('.events-holder').getAttribute('data-exclude'));

                const xhr = new XMLHttpRequest();
                xhr.open('POST', dynamic.ajax, true);
                xhr.onload = function () {
                    if (JSON.parse(this.response).data.events.length > 0) {
                        document.querySelector('.ajax-trigger').classList.remove('ajax-trigger');
                        document.querySelector('.events-holder').setAttribute('data-page', parseInt(document.querySelector('.events-holder').getAttribute('data-page'), 10) + 1);
                        setTimeout(() => {
                            el.parentNode.querySelectorAll('.grid-item').forEach((gridItem) => {
                                if (gridItem.classList.contains('inview-visible')) {
                                    gridItem.removeAttribute('data-inview');
                                }
                            });
                            document.querySelector('.events-holder').innerHTML += JSON.parse(this.response).data.events;
                            inView('.ajax-trigger');
                            inView('[data-inview]');
                        }, 500);
                    }
                    else {
                        document.querySelector('.ajax-trigger').parentNode.removeChild(document.querySelector('.ajax-trigger'));
                    }
                };
                xhr.send(formData);
            });
    }
}
